<template>
  <div @click="onClick" class="flex cursor-pointer items-baseline adapter-radio" :class="textColorClass">
    <div class="relative">
      <el-radio :disabled="disabled" ref="radio" :label="label">
        <span></span>
      </el-radio>
      <template v-if="view">
        <div class="absolute inset-0 z-10"></div>
      </template>
    </div>
    <div class="flex-1">
      <slot />
    </div>

    <div v-if="tip">
      <el-tooltip effect="light" :content="tip"  popper-class="answer-tooltip">
        <span class="text-medium ml-1">
          <i class="el-icon-question"></i>
          <span class="text-small text-theme-black-350" v-if="answerTipIconText">{{ answerTipIconText }}</span>
        </span>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdapterRadio',
  inject:{
    view:{
      default:false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: null,
      default: ''
    },
    richText: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    isCorrect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    answerTipIconText(){
      if(!this.$bus) return ''
      return this.$bus.survey?.otherSetting?.answerTipIconText
    },
    textColorClass() {
      return this.disabled ? 'text-theme-black-450' : 'text-theme-black-850'
    }
  },
  methods: {
    onClick() {
      if(this.view) return
      const radio = this.$refs.radio
      radio.model = radio.isDisabled ? radio.model : radio.label
    }
  }
}
</script>
